/** Shared dark-view form styling for the Portal admin surfaces. */
export const FIELD =
  'mt-3 w-full border-0 border-b border-paper/25 bg-transparent pb-2 font-sans text-sm tracking-wide2 text-paper placeholder:text-paper/30 focus:border-paper focus:outline-none'

export const SELECT = `${FIELD} appearance-none`

export const OPTION = 'bg-ink text-paper'

export const BUTTON_SOLID =
  'label border border-paper bg-paper px-6 py-3.5 text-ink transition-colors duration-150 ease-out hover:bg-paperDeep'

export const BUTTON_GHOST =
  'label border border-paper/40 px-6 py-3.5 text-paper transition-colors duration-150 ease-out hover:border-paper'

export const BUTTON_QUIET =
  'label text-paper/40 transition-colors duration-150 ease-out hover:text-paper'

/**
 * A page-section heading — one notch below the page's own h1, but a real
 * heading rather than the same 10px tracked-caps tag used for every field
 * caption. Introduced for the Call Sheet Builder (2026-09-08), which had
 * grown enough sections that "Crew", "Schedule", "Kit" and so on need to
 * read as clear breaks, not blend into the hint copy and field labels
 * beneath them. Safe to reuse anywhere a page has several stacked sections
 * that deserve the same visual weight.
 */
export const SECTION_TITLE =
  'font-display text-2xl leading-tight tracking-tight text-paper sm:text-3xl'

/** The one-line description directly under a SECTION_TITLE — quiet, so the
    heading above it stays the thing your eye lands on first. */
export const SECTION_HINT = 'label-sm mt-2 max-w-xl leading-relaxed text-paper/35'

/** A sub-group heading nested inside a SECTION_TITLE block (e.g. "Essential"
    under Shots, "Additional Client Contacts" under Crew) — the existing
    10px tracked-caps `label` treatment, just brighter than a field caption
    so it still reads as a heading of its own tier. */
export const SUBSECTION_TITLE = 'label block text-paper/65'
